import React from 'react';
import Lottie from 'lottie-react';
import { useSelector } from 'react-redux';
import { selectSpinerLoading } from 'slices/userProfile/reducer';


const LoaderModal: React.FC= () => {
    const loadingText = useSelector(selectSpinerLoading)
    if(!loadingText){
    return null
 }
    return (
    <div className='tailwind-prefix'>
  <div className="fixed inset-0 z-50 l:min-w-[600px] flex items-center justify-center bg-black/50 backdrop-blur-sm" role="status" aria-live="polite" aria-label={String(loadingText)}>
      <div className="w-fit rounded-2xl border border-gray-200 bg-white px-10 py-4 text-center shadow-lg dark:border-slate-700 dark:bg-slate-900">
      <Lottie  style={{
        height:120,
      }}   animationData={require('../assets/images/loading2.json')} />
    <div className='text-[16px] font-semibold text-gray-950 dark:text-slate-100'>
      {loadingText}
      </div>
      </div>
      
    </div>
    </div>
  
  );
};

export default LoaderModal;
